module.exports = __webpack_public_path__ + "static/media/ic_hints_buger.5759fce8.svg";